import { render } from "./CompanySummaryPanel.vue?vue&type=template&id=01c508b4&ts=true"
import script from "./CompanySummaryPanel.vue?vue&type=script&lang=ts"
export * from "./CompanySummaryPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__